// extracted by mini-css-extract-plugin
module.exports = {"appWraper":"App_appWraper__2HaXL"};